module.exports = __webpack_public_path__ + "static/business-img-b18904cfe08aad27298dfee1bf3c4238.jpeg";